const styles = theme => ({
  root: {
    color: '#ffffff',
    background: '#DB3E37',
    width: 20,
    height: 20,
    lineHeight: '21px',
    fontSize: '0.688rem',
    display: 'inline-block',
    borderRadius: '50%',
    position: 'relative',
    left: 14,
    top: -2,
    textAlign: 'center',
    border: 0,
  }
});

export default styles;
